import {FileModel} from "app/model/common/file";
import {Audit} from "app/model/common/audit";
import { BltnbClCd, BltnbClType, PrstsCdType } from "app/model/common/code";

export class PstatSearchModel {
  bltnbClCd: BltnbClType;
  titlNm?: string;
  prstsCd?: PrstsCdType;

  perPage?: number;
  page?: number;
  gridResponse: boolean;


  constructor(bltnbClCd: BltnbClType)  {
    this.bltnbClCd = bltnbClCd;
    this.perPage = 10;
    this.page = 1;
    this.titlNm = undefined;
    this.prstsCd = undefined;
    this.gridResponse = BltnbClCd.FAQ !== bltnbClCd;
  }
}

export class PstatModel extends Audit {
  constructor(bltnbClCd: BltnbClType, prstsCd?: PrstsCdType) {
    super();
    this.bltnbClCd = bltnbClCd;
    if(prstsCd) {
      this.prstsCd = prstsCd;
    }
  }

  pstatId?: string;
  bltnbClCd: BltnbClType;
  prstsCd?: PrstsCdType;
  titlNm?: string;
  pstatCtt?: string;
  inqCnt?: number;
  cmntList?: PstatCmntModel[];
  file?: FileModel;

  regrNm?: string;
}

export class PstatCmntModel extends Audit {
  constructor(pstatId: string) {
    super();
    this.pstatId = pstatId;
  }

  cmntId?: string;
  pstatId?: string;
  cmntCtt?: string;
  file?: FileModel;
}
